import React from 'react';
import { useQuery } from 'react-query';

import styled from 'styled-components';

import { getSalesPlaybook } from 'apis/RecommendationsAPI';
import Header from 'common/Header';
import { SALES_TALK_TRACKS_LABEL } from 'components/AiCompetitiveIntelligence/constants';
import RecommendationCompanyBreadcrumb from 'components/AiCompetitiveIntelligence/RecommendationCompanyBreadcrumb';
import { RecommendationsProvider } from 'components/AiCompetitiveIntelligence/RecommendationsContext';
import RecommendationsNotFound from 'components/AiCompetitiveIntelligence/RecommendationsNotFound';
import SalesPlaybookContent from 'components/AiCompetitiveIntelligence/SalesPlaybookContent';
import LoaderRibbed from 'components/lib/LoaderRibbed';
import { useAppSelector } from 'store/hook';

const Container = styled.div`
  width: 100%;
`;

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 200px;
`;

const IconContainer = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  margin-right: 10px;
  padding: 1px;
  background-image: linear-gradient(var(--white), var(--white)),
    linear-gradient(to bottom, var(--competitor-purple), var(--negative-orange) 50%, var(--flamingo-pink));
  background-origin: border-box;
  background-clip: content-box, border-box;
`;

const SalesTalkTracks = () => {
  const { selectedCommunity } = useAppSelector((state) => state.global);

  const { data, isLoading } = useQuery({
    queryKey: ['ai-competitive-intelligence-sales-playbook', selectedCommunity?.id],
    queryFn: () => getSalesPlaybook(selectedCommunity?.id ?? -1),
    enabled: Boolean(selectedCommunity?.id),
    refetchOnWindowFocus: false,
  });

  const isEmpty = !data || data.categories.length === 0;
  return (
    <RecommendationsProvider>
      <Container>
        <Header
          title={SALES_TALK_TRACKS_LABEL}
          breadcrumbs={<RecommendationCompanyBreadcrumb />}
          iconComponent={
            <IconContainer>
              <img src="/icons/ai-blob.svg" alt="ai-blob" height="30px" width="30px" />
            </IconContainer>
          }
        />
        {isLoading && (
          <LoaderContainer>
            <LoaderRibbed active />
          </LoaderContainer>
        )}
        {!isLoading && isEmpty && <RecommendationsNotFound />}
        {!isLoading && !isEmpty && data && <SalesPlaybookContent data={data} />}
      </Container>
    </RecommendationsProvider>
  );
};

export default SalesTalkTracks;
